import { render } from "./Base.vue?vue&type=template&id=370e1099"
const script = {}
script.render = render

export default script